// src/views/ExamView.js

import React from 'react';
import { useParams } from 'react-router-dom';
import Exam from '../components/Exam/Exam';

const ExamView = () => {
    const { listId } = useParams();
    return <Exam listId={listId} />;
};

export default ExamView;
